import { useEffect } from 'react';
import { useEmailDrafts } from './email-drafts-context';
import EmailCard from '../components/card/email-card';
import PropTypes from 'prop-types';
import EmailEmptyState from '../components/email-empty-state';
import EmailListSkeleton from '../components/email-list-skeleton';
import EmailControllerHeader from '../components/email-controller-header';
import { useIsFilterApplied } from '../utils/filter-search-helper';

const EmailDraftController = ({
  handleBulkSelect = () => {},
  selectedEmails = [],
  dateRange,
  selectedEmailAddresses,
  selectedNames,
}) => {
  const { updateFilters } = useEmailDrafts();
  const { drafts, loading, page, onPageChange, draftTotal, draftLimit, searchDrafts, hasEverHadData } =
    useEmailDrafts();
  const isFilterApplied = useIsFilterApplied({ dateRange, selectedEmailAddresses, selectedNames });
  useEffect(() => {
    const fetchDrafts = async () => {
      updateFilters({ dateRange, selectedEmailAddresses, selectedNames });
      if (isFilterApplied) {
        await searchDrafts({ dateRange, emailRecipients: selectedEmailAddresses, selectedNames });
      }
    };

    fetchDrafts();
  }, [isFilterApplied, searchDrafts, dateRange, selectedEmailAddresses, selectedNames, page, updateFilters]);

  useEffect(() => {
    return () => {
      onPageChange(1);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {loading ? (
        <EmailListSkeleton />
      ) : (
        <>
          {drafts.length === 0 && <EmailEmptyState isFilterApplied={isFilterApplied && hasEverHadData} />}
          {drafts.length > 0 && (
            <div className="email-controller-container">
              <EmailControllerHeader
                selectedCount={selectedEmails.length}
                totalCount={drafts.length}
                label="Drafts"
                page={page}
                onPageChange={onPageChange}
                totalPages={Math.ceil(draftTotal / draftLimit)}
              />
              {drafts.map((draft) => (
                <EmailCard key={draft.id} email={draft} handleBulkSelect={handleBulkSelect} />
              ))}
            </div>
          )}
        </>
      )}
    </>
  );
};

EmailDraftController.propTypes = {
  handleBulkSelect: PropTypes.func,
  selectedEmails: PropTypes.array,
  dateRange: PropTypes.shape({
    from: PropTypes.instanceOf(Date),
    to: PropTypes.instanceOf(Date),
  }),
  selectedEmailAddresses: PropTypes.array,
  selectedNames: PropTypes.array,
};

export default EmailDraftController;
